export default __webpack_public_path__ + "static/media/who-01.92eab072.png";